import _ from 'lodash';

import { Types } from 'app/actions/account';
import utils from 'app/reducers/utils';

const initialState = {
  updatingAccount: false,
  emailChangeSent: false,
  validations: null,
  setNewPwPending: false,
  setNewPwSuccess: false,
  setNewPwFailed: false,
  setNewPwValidations: null,
  setPrefsPending: false,
  setPrefsKey: null,
  localPrefs: {},
  sessions: null,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.UPDATE}_PENDING`]: (state, _action) => {
    return {...state,
      updatingAccount: true,
      validations: null,
      emailChangeSent: false,
    };
  },
  [`${Types.UPDATE}_RESOLVED`]: (state, {email}) => {
    return {...state,
      updatingAccount: false,
      validations: null,
      emailChangeSent: !!email,
    };
  },
  [`${Types.UPDATE}_REJECTED`]: (state, {error}) => {
    const validations = _.get(error, 'response.data.error.validations', null);
    return {...state,
      updatingAccount: false,
      validations,
    };
  },

  [`${Types.PARTIAL_UPDATE}_PENDING`]: (state, _action) => {
    return {...state,
      updatingAccount: true,
    };
  },
  [`${Types.PARTIAL_UPDATE}_RESOLVED`]: (state, {email}) => {
    return {...state,
      updatingAccount: false,
    };
  },
  [`${Types.PARTIAL_UPDATE}_REJECTED`]: (state, {error}) => {
    return {...state,
      updatingAccount: false,
    };
  },

  [`${Types.SET_NEW_PW}_PENDING`]: (state, _action) => {
    return {...state,
      setNewPwPending: true,
      setNewPwSuccess: false,
      setNewPwFailed: false,
      setNewPwValidations: null,
    };
  },
  [`${Types.SET_NEW_PW}_RESOLVED`]: (state, {email}) => {
    return {...state,
      setNewPwPending: false,
      setNewPwSuccess: true,
      setNewPwFailed: false,
      setNewPwValidations: null,
    };
  },
  [`${Types.SET_NEW_PW}_REJECTED`]: (state, {error}) => {
    const validations = _.get(error, 'response.data.error.validations', null);
    return {...state,
      setNewPwPending: false,
      setNewPwSuccess: false,
      setNewPwFailed: true,
      setNewPwValidations: validations,
    };
  },

  [`${Types.SET_PREFS}_PENDING`]: (state, {prefs, key}) => {
    return {...state,
      setPrefsPending: true,
      setPrefsKey: key,
      localPrefs: {...state.localPrefs,
        ...prefs,
      },
    };
  },
  [`${Types.SET_PREFS}_RESOLVED`]: (state, {key}) => {
    if (key !== state.setPrefsKey) return state;
    return {...state,
      setPrefsPending: false,
    };
  },
  [`${Types.SET_PREFS}_REJECTED`]: (state, {key}) => {
    if (key !== state.setPrefsKey) return state;
    return {...state,
      setPrefsPending: false,
    };
  },

  [`${Types.SESSIONS_SEARCH}_PENDING`]: (state, action) => {
    return {...state,
      sessions: null,
    };
  },
  [`${Types.SESSIONS_SEARCH}_RESOLVED`]: (state, action) => {
    return {...state,
      sessions: action.result.sessions,
    };
  },

});

export default reducer;
